import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alert, setAlert] = useState(null);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setAlert(null);

    // EmailJS credentials (Replace with your actual credentials)
    const serviceId = "service_m3s0y1c";
    const templateId = "template_a5y5gfw";
    const publicKey = "I6wlTZBM6o8cirWEW";

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      address: formData.address,
      message: formData.message,
      to_email: "info@junkdroid.com",
    };

    try {
      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      setAlert({
        type: "success",
        message: "Email has been sent successfully!",
      });

      // Reset form data
      setFormData({
        name: "",
        email: "",
        phone: "",
        address: "",
        message: "",
      });
    } catch (error) {
      setAlert({
        type: "danger",
        message: "Failed to send email. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6">
          <label>
            Your name <span>*</span>
          </label>
          <input
            type="text"
            placeholder="Julia William"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-6">
          <label>
            Email Address <span>*</span>
          </label>
          <input
            type="email"
            placeholder="Email Address"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-6">
          <label>
            Phone Number <span>*</span>
          </label>
          <input
            type="tel"
            placeholder="Your phone number"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-6">
          <label>
            Address <span>*</span>
          </label>
          <input
            type="text"
            placeholder="Write your address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-12">
          <label>
            Detail <span>*</span>
          </label>
          <textarea
            name="message"
            cols={5}
            rows={5}
            placeholder="Write detail..."
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-12">
          <button
            className="btn removal-btn"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Message"} &nbsp;
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chat-square-fill"
              viewBox="0 0 16 16"
            >
              <path d="M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
            </svg>
          </button>
        </div>
        {alert && (
          <div className={`alert alert-${alert.type} mt-3`} role="alert">
            {alert.message}
          </div>
        )}
      </div>
    </form>
  );
};

export default ContactForm;
